import { Body, palettes, TinyTitle } from '@indigo-ag/component-module';
import { AgFinancingPhaseStatus } from '@indigo-ag/schema';
import i18next from 'core/i18n';
import React, { useContext } from 'react';

import { UserContext } from '../../../../../../core/components/GateWay/GateWay';
import { NotificationSection, NotificationSectionStatus } from '../../shared/NotificationSection/NotificationSection';

const NOT_SHOW_STATUSES = [AgFinancingPhaseStatus.NOT_STARTED, AgFinancingPhaseStatus.IN_PROGRESS];

interface BackgroundCheckPhaseProps {
  decidedAt?: Date;
  decidedBy?: string;
  notes?: string;
  phaseStatus?: AgFinancingPhaseStatus;
}

export const DecisionNotificationSection: React.FunctionComponent<BackgroundCheckPhaseProps> = ({
  decidedAt,
  decidedBy,
  notes,
  phaseStatus = AgFinancingPhaseStatus.NOT_STARTED
}) => {
  /**
   * Context
   */
  const { isCreditLead, isCreditAnalyst, isSuper } = useContext(UserContext);
  let phaseStatusVariant: NotificationSectionStatus;
  let phaseTitle: string;

  switch (phaseStatus) {
    case AgFinancingPhaseStatus.CLEAR: {
      phaseStatusVariant = 'success';
      phaseTitle = i18next.t('approved');
      break;
    }
    case AgFinancingPhaseStatus.DENIED: {
      phaseStatusVariant = 'error';
      phaseTitle = i18next.t('denied');
      break;
    }
    case AgFinancingPhaseStatus.AWAITING_MANAGER_APPROVAL: {
      phaseStatusVariant = 'warning';
      phaseTitle = i18next.t('waitingForApproval');
      break;
    }
    case AgFinancingPhaseStatus.NOT_STARTED: {
      phaseStatusVariant = 'success';
      phaseTitle = '';
      break;
    }
    case AgFinancingPhaseStatus.IN_PROGRESS: {
      phaseStatusVariant = 'warning';
      phaseTitle = i18next.t('inProgress');
      break;
    }
    default: {
      phaseStatusVariant = 'success';
      phaseTitle = '';
      break;
    }
  }

  if (NOT_SHOW_STATUSES.includes(phaseStatus) || !(isCreditLead || isCreditAnalyst || isSuper)) {
    return null;
  }

  return (
    <NotificationSection status={phaseStatusVariant} title={phaseTitle} updatedAt={decidedAt} updateBy={decidedBy}>
      {notes && (
        <>
          <TinyTitle className="mt-2 mb-1 text-transform-capitalize" style={{ color: palettes.brand.gray[700] }}>
            {i18next.t('decisionNotes')}
          </TinyTitle>
          <Body className="mt-1">{notes}</Body>
        </>
      )}
    </NotificationSection>
  );
};
